const breakpoints = {
  values: {
    xs: 0,
    sm: 768, // 600
    md: 900,
    lg: 1200,
    xl: 1472, // 1536
  }
};

export default breakpoints;
